var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('AggridList',{attrs:{"componentGridOptions":_vm.gridOptions,"excelColumns":["id", "name", "slug"],"service":_vm.service}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }